import { CategoricalCanvasLayout } from './CategoricalCanvasLayout.js';
import { CategoricalGridLayout } from './CategoricalGridLayout.js';
import { CategoricalGridZeroLineLayout } from './CategoricalGridZeroLineLayout.js';
import { plotLayout } from '../../core/components/chart-grid/ChartGrid.sty.js';
import { CategoricalBarChartOverlaysBorder } from '../components/interactions/CategoricalBarChartOverlaysBorder.js';
import { CategoricalThresholdIndicators } from '../components/thresholds/CategoricalThresholdIndicators.js';

export const CategoricalBarChartPlot = () => (
  <>
    <CategoricalGridLayout />
    <svg className={plotLayout}>
      <CategoricalThresholdIndicators />
    </svg>
    <CategoricalCanvasLayout />
    <CategoricalGridZeroLineLayout />
    <CategoricalBarChartOverlaysBorder />
  </>
);

CategoricalBarChartPlot['displayName'] = 'CategoricalBarChartPlot';
